(function () {

    "use strict";

    angular
        .module("vertica.query", [])
        .factory("query", query);

    query.$inject = [
        "$location",
        "$window",
        "util"
    ];

    function query($location, $window, util) {

        var PAGING_PARAM_NAME = "Page";
        var LAST_FACET_NAME = "Last";
        var QUERY_FACET_NAME = "q";
        var CLIENT_URL_FACET_NAME = "clientUrl";
        var initielClientUrl = undefined;

        return {
            contains: contains,
            get: get,
            update: update,
            isEmpty: isEmpty,
            clear: clear,
            count: count,
            persistClientUrl: persistClientUrl,
            restoreClientUrl: restoreClientUrl
        };


        /**
         * Method that can check if a certain `param`'s value in the search query string contains a certain `value`.
         *
         * @ngdoc method
         * @name contains
         *
         * @param {String} param - Key of which value to check agains for occurences.
         * @param {*} value - Value to check for.
         *
         * @returns {Boolean}
         */

        function contains(param, value) {

            return includes(
                get(param),
                value
            );
        }


        /**
         * Use this method to fetch the search query string or the value of a param.
         * If the `param` argument is omitted, the method will return the search query object with all the params and their values, otherwise it will return the value of
         * the specified param.
         *
         * @ngdoc method
         * @name get
         *
         * @param {String} [param] - Key of which value to get.
         *
         * @returns {*}
         */

        function get(param) {

            return param
                ? $location.search()[param]
                : $location.search();
        }

        /**
         * Use this method to update the search query in the url.
         * It will only update the angular search query part of the url (the part that is usually after a `#`/`#!` if HTML5 mode is not enabled). Updates the query string with ampersand separated keys/value
         * pairs (`?catalog=87&page=2`) and for keys that hold multiple values (array of values) it will use commas to separate them (`?catalog=4&page=2&brands=tullamore,cherry,don`).
         * If a value that already exists is sent for a parameter (that also exists) and it holds multiple values, it will remove that value from the collection.
         * Note that if a search query update is made for any of the params but not the page param and the page param is present,
         * then the page param will be removed from the search query string.
         *
         * @ngdoc method
         * @name update
         *
         * @param {String} param - Key of which value should be updated (`catalog`).
         * @param {*} value - Value with which to replace/update the key's existing value in the url.
         * @param {Boolean} [replace] - Replace value instead of update.
         */

        function update(param, value, replace) {

            var values,
                path = $location.path(),
                search = get();

            // Page param has already been set, we might need to delete it
            if (search[PAGING_PARAM_NAME]) {

                var setPageTo1 = param === PAGING_PARAM_NAME && value === 1;

                if (setPageTo1) {
                    value = null;
                }

                // Delete if we're updating another param
                if (param !== PAGING_PARAM_NAME) {
                    delete search[PAGING_PARAM_NAME];
                }
            }

            if (value) {

                if (!(values = search[param]) || replace) {
                    search[param] = value;
                } else {
                    values = parse(values);

                    if (includes(values, value)) {
                        pluck(values, value);
                    } else {
                        values.push(value);
                    }

                    if (values.length) {
                        // sorted to optimize http caching (so that the order in which the value was applied is not important)
                        search[param] = values.sort().join();
                    } else {
                        delete search[param];
                    }
                }
            } else if (replace && search[param]) {

                // no value specified so we need to remove the parameter
                delete search[param];
            }

            if (search[param] && param !== PAGING_PARAM_NAME) {

                search[LAST_FACET_NAME] = param;

            } else {

                var current = search[LAST_FACET_NAME];

                if (current === param)
                    delete search[LAST_FACET_NAME];
            }

            $location
                .path((path.length && path) || "/")
                .search(search);
        }

        function clear(clearSearchParam) {
            var params = {};

            var queryValue = get(QUERY_FACET_NAME);
            if (queryValue && !clearSearchParam) {
                params[QUERY_FACET_NAME] = queryValue;
            }

            var clientUrl = get(CLIENT_URL_FACET_NAME);
            if (clientUrl) {
                params[CLIENT_URL_FACET_NAME] = clientUrl;
            }

            $location.search(params);
        }

        function isEmpty() {

            return util.isEmpty($location.search());
        }

        function count() {

            var filtered = Object.keys($location.search())
                .filter(function (x) {
                    return x !== LAST_FACET_NAME;
                });

            return filtered.length;
        }

        function persistClientUrl() {

            var clientUrl = $window.location.hash;
            // Only save client url if it's more than "#", if this the first search and client url is not already encoded
            if (initielClientUrl == undefined && clientUrl.length > 1 && clientUrl.indexOf(QUERY_FACET_NAME + "=") === -1 && clientUrl.indexOf(CLIENT_URL_FACET_NAME) === -1 && clientUrl !== "#/") {
                initielClientUrl = clientUrl;
                clear();
                update(CLIENT_URL_FACET_NAME, encodeURI(clientUrl));
            } else if (!initielClientUrl) {
                initielClientUrl = clientUrl;
            }
        }

        function restoreClientUrl() {
            var clientUrl = get(CLIENT_URL_FACET_NAME);

            if (clientUrl) {
                $window.location.hash = decodeURI(clientUrl);
                initielClientUrl = undefined;
            }
        }

        /**
         * Function used for parsing query param values.
         * If a param's value contains comma separated values (`'jane,brian,lars,john'`),
         * this method will convert it into an array of the same values (`[jane,brian,lars,john]`).
         * If the value is instead an array it will return the array.
         *
         * @ngdoc function
         * @name parse
         *
         * @param {(String|Array)} value - Value to parse.
         * @param {Boolean} i - Case insensitive (lowercase all string values).
         *
         * @returns {Array} If the `value` is an array, it returns it, if it's a string, it returns an array of the string split by `,`.
         * If none of the before, an empty array.
         */

        function parse(value, i) {

            return (
                angular.isArray(value)
                    ? value
                    : (angular.isString(value) ? value.split(",") : [])
            ).map(
                i ? lowercase : noop
            );
        }


        /**
         * Method that can check if a certain `obj` contains a certain `value`.
         * The search performed is case insensitive. If a string is found, it will be lowercased (both the in the `obj` - if is an array or a string - and the `value`).
         *
         * @private
         *
         * @param {*} obj - Abstract value that should be checked if it contains the `value`.
         * @param {*} value - Value to check for.
         *
         * @returns {Boolean}
         */

        function includes(obj, value) {

            var alt,
                result = parse(obj, true);

            if (!result.length) alt = obj;

            return util.includes(
                alt || result,
                angular.isString(value) ? value.toLowerCase() : value
            );
        }


        /**
         * Remove a `value` from an `arr`.
         * Note that the search is case insensitive (meaning `BHK` is the same as `bhk`).
         * Keep in mind that the method alters the original array.
         *
         * @private
         *
         * @param {Array} arr
         * @param {*} value
         *
         * @returns {Array} Array with removed values.
         */

        function pluck(arr, value) {

            var clone = arr.slice(0),
                idx = clone.map(lowercase).indexOf(lowercase(value));

            if (idx === -1) return arr;

            return arr.splice(
                idx,
                1
            );
        }


        /**
         * Map predicate for lowercasing a string value.
         *
         * @private
         *
         * @param {*} value
         *
         * @returns {*}
         */

        function lowercase(value) {

            return angular.isString(value)
                ? value.toLowerCase()
                : value;
        }


        /**
         * Blank map predicate.
         *
         * @private
         *
         * @param {*} value
         *
         * @returns {*}
         */

        function noop(value) {
            return value;
        }
    }

})();
